import React from 'react';
import { graphql, useFragment } from 'react-relay/hooks';
export const formatUserName = ({ fullName, employeeId }) => {
    return employeeId ? `${fullName} #${employeeId}` : fullName;
};
export const UserNameLabel = (props) => {
    const { user: userRef } = props;
    const user = useFragment(graphql `
      fragment UserNameLabel_user on User {
        employeeId
        fullName
      }
    `, userRef);
    return (<>
      {user.fullName}
      {user.employeeId && (<span style={{ color: '#888', fontSize: '0.875em', fontWeight: 'normal', marginLeft: '0.25em' }}>
          #{user.employeeId}
        </span>)}
    </>);
};
export default UserNameLabel;
